"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "objectType", {
  enumerable: true,
  get: function get() {
    return _object.default;
  }
});
Object.defineProperty(exports, "dateType", {
  enumerable: true,
  get: function get() {
    return _date.default;
  }
});
Object.defineProperty(exports, "functionType", {
  enumerable: true,
  get: function get() {
    return _function.default;
  }
});
Object.defineProperty(exports, "infinityType", {
  enumerable: true,
  get: function get() {
    return _infinity.default;
  }
});
Object.defineProperty(exports, "nanType", {
  enumerable: true,
  get: function get() {
    return _nan.default;
  }
});
Object.defineProperty(exports, "regexpType", {
  enumerable: true,
  get: function get() {
    return _regexp.default;
  }
});
Object.defineProperty(exports, "symbolType", {
  enumerable: true,
  get: function get() {
    return _symbol.default;
  }
});
Object.defineProperty(exports, "undefinedType", {
  enumerable: true,
  get: function get() {
    return _undefined.default;
  }
});
exports.types = void 0;

var _object = _interopRequireDefault(require("./object"));

var _date = _interopRequireDefault(require("./date"));

var _function = _interopRequireDefault(require("./function"));

var _infinity = _interopRequireDefault(require("./infinity"));

var _nan = _interopRequireDefault(require("./nan"));

var _regexp = _interopRequireDefault(require("./regexp"));

var _symbol = _interopRequireDefault(require("./symbol"));

var _undefined = _interopRequireDefault(require("./undefined"));

var types = [_date.default, _function.default, _nan.default, _infinity.default, _regexp.default, _symbol.default, _undefined.default];
exports.types = types;